module.exports = {"id":"214327","name":"Vladimir Hernández","rating":"77","photo":"./data/images/photos/3/214327.png","club":{"name":"Atl. Nacional","logo":"./data/images/clubs/Atl.Nacional.png"},"positions":["MOC","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VladimirHernandez0.json
// module id = 4300
// module chunks = 0